import VueNoty from 'vuejs-noty'
import Vue from "vue";
Vue.use(VueNoty);


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/noty.js